// extracted by mini-css-extract-plugin
export var banner = "_jt-0";
export var settingRow = "_jt-2";
export var titleIcon = "_jt-1";